import { articleMetaBySlug } from "./meta";

export const meta = articleMetaBySlug["treadmill-or-outside"]!;

export function Body() {
  return (
    <>
      <p>
        Is running on a treadmill easier than running outside? Without wind resistance it
        costs a little less energy at the same speed. A study from 1996 measured how much
        incline it takes to make up for it.
      </p>

      <h2>What the researchers did</h2>
      <p>
        Nine trained male runners ran six-minute efforts at six speeds, from 10.5 to 18 km/h,
        which is from about 5:42 to 3:20 per km. They did this on a treadmill set at 0, 1, 2 and
        3 percent incline, and once on a flat road. The researchers measured their oxygen
        uptake at each speed.
      </p>

      <h2>What they found</h2>
      <p>
        With the treadmill at 1 percent incline, the energy cost matched running outside at all
        speeds tested. At the two slowest speeds, 5:42 and 5:00 per km, running on the flat
        treadmill also matched running outside. At faster speeds, the flat treadmill was easier.
      </p>

      <h2>What it means for you</h2>
      <p>
        Set the treadmill to 1 percent incline, and your pace targets work indoors too. If you
        run slower than about 5:00 per km, the difference is small, and a flat treadmill is
        close enough.
      </p>
      <p>
        Treadmills are not always accurately calibrated, and watches often estimate pace poorly
        indoors. Use the speed on the treadmill, and check your effort and breathing. If a pace
        feels much harder or easier than outside, trust the effort.
      </p>

      <h2>What the study can't tell you</h2>
      <p>
        The runners were well trained and used to treadmills, and the efforts lasted about five
        minutes. Long runs on a treadmill can feel different, for example because of heat
        indoors.
      </p>

      <h2>How we use it</h2>
      <p>
        Pace targets in PX7 Training are made for running outside on flat ground. On a
        treadmill, use 1 percent incline and the same targets.
      </p>

      <h2>Source</h2>
      <ul>
        <li>
          Jones & Doust (1996), A 1% treadmill grade most accurately reflects the energetic cost
          of outdoor running.{" "}
          <a href="https://doi.org/10.1080/02640419608727717">Journal of Sports Sciences</a>.
        </li>
      </ul>
    </>
  );
}
